import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { Settings, Menu } from 'lucide-react';
import NotificationBell from '../NotificationBell';
import UserMenu from './UserMenu';

/** Su telefono le azioni stanno in basso, col menu a destra. */
export const MobileBottomBar = ({ onMenuClick }) => {
  const navigate = useNavigate();

  return (
    <nav
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 h-16 border-t border-border bg-card/95 backdrop-blur-md"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      data-testid="mobile-bottom-bar"
    >
      <div className="h-16 px-2 flex items-center justify-around">
        <UserMenu testId="user-menu-trigger-mobile" />
        <div className="w-11 flex justify-center">
          <NotificationBell collapsed topbar testId="notification-bell-mobile" />
        </div>
        <Button variant="ghost" size="icon" className="w-11 h-11"
          onClick={() => navigate('/settings')} data-testid="bottom-bar-settings">
          <Settings className="w-5 h-5" />
        </Button>
        <Button variant="ghost" size="icon" className="w-11 h-11"
          onClick={onMenuClick} data-testid="mobile-menu-toggle">
          <Menu className="w-6 h-6" />
        </Button>
      </div>
    </nav>
  );
};

export default MobileBottomBar;
